export const titleCase = (str) => {
    if(!str || str === 'n/a' || str === 'N/A' || str === '') return '';
    let splitStr = str.toLowerCase().replaceAll('_', ' ').split(' ');
    for (var i = 0; i < splitStr.length; i++) {
        splitStr[i] = splitStr[i].charAt(0).toUpperCase() + splitStr[i].substring(1);     
    };
    return splitStr.join(' '); 
};

export const flattenString = (string) => {
    // Removes leading and trailing wite spaces...
    let stringCleaned = string.replace(/^\s+|\s+$/g, '');
    // Replaces spaces between words wit an underscore...
    stringCleaned = stringCleaned.replace(/\s/g, '_');
    // Returns te result in lowercase.
    return stringCleaned.toLowerCase();
};

// Cookie Tools
export const setCookie = (cname, cvalue, exdays) => {
    let d = new Date();
    d.setTime(d.getTime() + (exdays*24*60*60*1000));
    let expires = 'expires='+ d.toUTCString();
    document.cookie = cname + '=' + cvalue + ';' + expires + ';path=/';
};

export const getCookie = (cname) => {
    let name = cname + '=';
    let decodedCookie = decodeURIComponent(document.cookie);
    let ca = decodedCookie.split(';');
    for(let i = 0; i <ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) === ' ') {
            c = c.substring(1);
        }
        if (c.indexOf(name) === 0) {
            return c.substring(name.length, c.length);
        }
    }
    return '';
};

export const checkCookie = (cname) => {
    let cookie = getCookie(cname);
    if (cookie && cookie !== '') {
        return true
    } 
    return false;
};

export const buildKeywordLink = (link, tracking, keyword, isOptOut) => {
    let linkout = link; // eslint-disable-next-line
    if (!linkout || linkout === '' || linkout === 'N/A') return tracking.r || 'N/A'; // eslint-disable-next-line
    linkout = linkout.replace('${sid}', tracking.SID); // eslint-disable-next-line
    linkout = linkout.replace('${eid}', tracking.EID); // eslint-disable-next-line
    linkout = linkout.replace('${uid}', tracking.UID); // eslint-disable-next-line
    linkout = linkout.replace('${kwd}', encodeURIComponent(keyword)); // eslint-disable-next-line
    linkout = linkout.replace('${hsid}', tracking.HSID); // eslint-disable-next-line
    linkout = linkout.replace('${em}', isOptOut ? '' : tracking.EMAIL); // eslint-disable-next-line
    linkout = linkout.replace('${first}', tracking.fname); // eslint-disable-next-line
    linkout = linkout.replace('${last}', tracking.lname); // eslint-disable-next-line
    linkout = linkout.replace('${adrs}', tracking.address); // eslint-disable-next-line
    linkout = linkout.replace('${city}', tracking.city); // eslint-disable-next-line
    linkout = linkout.replace('${state}', tracking.location); // eslint-disable-next-line
    linkout = linkout.replace('${zip}', tracking.zip); // eslint-disable-next-line
    return linkout;
};